import { memoize } from "lodash";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import { hasParentComponentVariable } from "src/shared/store/component-graph-v2";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import { useComponentVariableMutableFilter } from "src/shared/store/component-variable-mutable/composables/useComponentVariableMutableSetFilter";
import { useComponentVariableSearchables } from "src/shared/store/component-variable-searchable/composables/useComponentVariableSearchables";
import { computed, reactive } from "vue";
import { useComponentVariableAdvancedMasterSwitch } from "../../composables/useComponentVaraiableAdvancedMasterSwitch";
export const provideFilteredComponentVariableNames = memoize((componentMutableKey) => {
    const { showAdvanced } = useComponentVariableAdvancedMasterSwitch();
    const { componentMutable } = useComponentMutable(componentMutableKey);
    const componentId = computed(() => { var _a; return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.component_id; });
    const { componentVariableMutableFilter } = useComponentVariableMutableFilter(componentMutableKey);
    const search = computed(() => componentVariableMutableFilter.value.search);
    const { componentVariableSearchables } = useComponentVariableSearchables(componentId);
    const fuzzySearchedSearchables = useFuzzySearch(search, componentVariableSearchables, ["name", "displayName", "valuesSerialized", "builtValuesSerialized"]);
    const filteredByOtherParameters2 = computed(() => {
        return fuzzySearchedSearchables.value.filter((variable) => {
            const everyConditionMustBeTruthy = [
                !variable.isUIDisplayOnly,
            ];
            if (componentVariableMutableFilter.value.showOnlyTranslatable) {
                everyConditionMustBeTruthy.push(variable.isTranslatable);
            }
            if (componentVariableMutableFilter.value.showOnlyEssential) {
                everyConditionMustBeTruthy.push(variable.importance === "ESSENTIAL");
            }
            if (componentVariableMutableFilter.value.primaryCategory) {
                everyConditionMustBeTruthy.push(variable.primaryCategory ===
                    componentVariableMutableFilter.value.primaryCategory);
            }
            if (componentVariableMutableFilter.value
                .showOnlyNotUsingDefaultValue &&
                variable.nodeType) {
                everyConditionMustBeTruthy.push(hasParentComponentVariable(variable.nodeType) &&
                    !variable.isInheriting);
            }
            if (!showAdvanced()) {
                everyConditionMustBeTruthy.push(!variable.isAdvanced);
            }
            if (componentVariableMutableFilter.value
                .showOnlyUsingDefaultValue &&
                variable.nodeType) {
                everyConditionMustBeTruthy.push(variable.isInheriting);
            }
            if (everyConditionMustBeTruthy.length === 0) {
                return true;
            }
            return everyConditionMustBeTruthy.every((condition) => condition);
        });
    });
    const filteredVariableNames = computed(() => {
        const filteredThings = reactive({
            primaryCategories: new Set(),
            secondaryCategories: new Set(),
            variableNames: new Set(),
        });
        filteredByOtherParameters2.value.forEach((variable) => {
            filteredThings.primaryCategories.add(variable.primaryCategory);
            filteredThings.secondaryCategories.add(variable.secondaryCategory);
            filteredThings.variableNames.add(variable.name);
        });
        return filteredThings;
    });
    return {
        filteredVariableNames,
    };
});
